//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import dateSelect from '@/components/date/dateSelect';
import weekSelect from '@/components/date/weekSelect';
import monthSelect from '@/components/date/monthSelect';
import moment from 'moment'; // import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin'

import { getAction } from '@/api/manage';
export default {
  name: 'EvaluateScoreList',
  mixins: [JeecgListMixin],
  components: {
    dateSelect: dateSelect,
    weekSelect: weekSelect,
    monthSelect: monthSelect
  },
  data: function data() {
    return {
      pagePath: '/om/evaluate/score/analysis',
      pageTitle: '评价与得分',
      reportType: '2',
      limitSelectDate: {},
      autoLoadInit: false,
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center'
      }, {
        title: '设施运行情况',
        align: 'center',
        children: [{
          dataIndex: 'F11',
          colName: 'F11',
          title: '设施运行率',
          align: 'center'
        }, {
          dataIndex: 'FF11',
          colName: 'FF11',
          title: '得分',
          align: 'center'
        }, {
          dataIndex: 'F12',
          colName: 'F12',
          title: '平均水力负荷率',
          align: 'center'
        }, {
          dataIndex: 'FF12',
          colName: 'FF12',
          title: '得分',
          align: 'center'
        }]
      }, {
        title: '环境效益',
        align: 'center',
        children: [{
          dataIndex: 'F21',
          colName: 'F21',
          title: '出水水质达标率',
          align: 'center'
        }, {
          dataIndex: 'FF21',
          colName: 'FF21',
          title: '得分',
          align: 'center'
        }]
      }, {
        title: '能耗物耗',
        align: 'center',
        children: [{
          dataIndex: 'F31',
          colName: 'F31',
          title: '单位污水处理电耗',
          align: 'center'
        }, {
          dataIndex: 'FF31',
          colName: 'FF31',
          title: '得分',
          align: 'center'
        }, {
          dataIndex: 'F32',
          colName: 'F32',
          title: '单位污水处理药耗',
          align: 'center'
        }, {
          dataIndex: 'FF32',
          colName: 'FF32',
          title: '得分',
          align: 'center'
        }]
      }, {
        title: '运行管理',
        align: 'center',
        children: [{
          dataIndex: 'F41',
          colName: 'F41',
          title: '运行管理制度',
          align: 'center'
        }, {
          dataIndex: 'F42',
          colName: 'F42',
          title: '运行维护记录',
          align: 'center'
        }, {
          dataIndex: 'F43',
          colName: 'F43',
          title: '环境与标识',
          align: 'center'
        }, {
          dataIndex: 'F44',
          colName: 'F44',
          title: '安全管理',
          align: 'center'
        }]
      }, {
        title: '公众满意度',
        align: 'center',
        children: [{
          dataIndex: 'F51',
          colName: 'F51',
          title: '有效投诉次数',
          align: 'center'
        }, {
          dataIndex: 'F52',
          colName: 'F52',
          title: '投诉处理率',
          align: 'center'
        }]
      }, {
        dataIndex: 'total',
        colName: 'total',
        title: '总分',
        align: 'center'
      }, {
        dataIndex: 'grade',
        colName: 'grade',
        title: '等级',
        align: 'center'
      }],
      st: ''
    };
  },
  props: ['scope', 'scopeId'],
  watch: {// currentSiteType(value) {
    //   this.st = value
    //   console.log(value)
    //   if (this.st == null || this.st == '') {
    //     this.$message.warning('请选择监测类型')
    //     this.$router.push('/base/wart')
    //   } else if (this.st == 32) {
    //     console.log(111111)
    //     this.$router.push('/om/report/EvaluateScoreAnalysis')
    //   } else {
    //     this.$router.push('/base/wart')
    //   }
    // },
    // currentSiteId(value) {
    //   var ids = this.getTreeCurrentId()
    //   this.queryParam.scope = ids[0]
    //   this.queryParam.scopeId = ids[1]
    //   this.limitSelectDate = {
    //     min: moment().startOf('day').subtract(1, 'months'),
    //     max: moment().endOf('day'),
    //   }
    //   this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD')
    //   this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD')
    //   if (ids[0] == 1) {
    //     this.siteId = ids[1]
    //     // 根据站点id
    //     this.spliceColumn(this.siteColumn)
    //     // if (this.st == null || this.st == '') {
    //     //   this.$message.warning('请选择监测类型')
    //     // }
    //     // this.$router.push('/base/wart')
    //   } else {
    //     // 根据区域id
    //     this.spliceColumn(this.siteColumn, 1)
    //     // if (this.st == null || this.st == '') {
    //     //   this.$message.warning('请选择监测类型')
    //     // } else if (this.st == 32) {
    //     //   this.$router.push('/om/report/EvaluateScoreAnalysis')
    //     //   this.loadData()
    //     // } else {
    //     //   this.$router.push('/base/wart')
    //   }
    // },
    //this.queryParam.reportType = this.reportType
    //this.loadData()
  },
  // currentSiteName(value) {
  //   this.siteName = value
  // },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'months'),
      max: moment().endOf('day')
    };
    this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
    this.queryParam.scope = this.scope;
    this.queryParam.scopeId = this.scopeId;
    this.spliceColumn(this.siteColumn, 1);
    this.loadData();
  },
  computed: {},
  methods: {
    loadData: function loadData() {
      this.queryParam.reportType = this.reportType;
      this.initTableData();
    },
    // 周变化
    weekChange: function weekChange(value) {
      this.queryParam.quantum = value[0] + '-' + value[1];
    },
    // 月变化
    monthChange: function monthChange(value) {
      this.queryParam.quantum = value;
    },
    // 报表类型变化
    reportTypeChange: function reportTypeChange(e) {
      this.reportType = e.target.value;

      if (this.reportType == '3') {
        this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
        this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
      }
    },
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
    },
    initTableData: function initTableData() {
      var _this = this;

      //debugger
      //if(!this.url.list){
      // this.$message.error("请设置url.list属性!")
      // return
      // }
      this.loading = true;
      getAction(this.pagePath, this.queryParam).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result;
        } else {
          _this.$message.warning('系统异常=>' + res.message);
        }

        _this.loading = false;
      });
    }
  }
};